import { render, staticRenderFns } from "./ScriptLoader.vue?vue&type=template&id=7a8c1997&"
import script from "./ScriptLoader.vue?vue&type=script&lang=ts&"
export * from "./ScriptLoader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports